import React, { useMemo, useState } from 'react';
import { DatePicker } from './datepicker';
import { Text } from 'wix-ui-tpa/cssVars';
import { TimeSlots } from './slots';
import { classes } from './time-slot-picker.st.css';
import { useTranslation } from '../../../contexts/translation-context';
import { formatTimezone } from '../utils/formatTimezone';
import { useConfig } from '../../../contexts/config-context';
import { useFieldActions } from '../../../contexts/field-actions-context';
export const TimeSlotPicker = _ref => {
  let {
    appointmentFieldProps,
    appointmentState,
    setAppointmentState,
    isReloadingSlots
  } = _ref;
  const {
    locale
  } = useConfig();
  const {
    t
  } = useTranslation();
  const {
    formatInfo
  } = appointmentFieldProps;
  const {
    actions
  } = useFieldActions();
  const timezone = useMemo(() => formatTimezone({
    timezone: appointmentState.timezone,
    language: locale
  }), [appointmentState.timezone, locale]);
  const [isFetchingDates, setIsFetchingDates] = useState(false);
  const updateAppointmentState = data => {
    setAppointmentState({
      ...appointmentState,
      ...data
    });
  };
  const handleOnWeekChange = async (fromDate, toDate) => {
    setIsFetchingDates(true);
    const availabilityDates = await (actions == null || actions.getAvailabilityDates == null ? void 0 : actions.getAvailabilityDates({
      serviceId: appointmentFieldProps.initialData.service.id,
      timeZone: (appointmentState == null ? void 0 : appointmentState.timezone) || '',
      fromDate,
      toDate
    }));
    setAppointmentState({
      ...appointmentState,
      availabilityDates
    });
    setIsFetchingDates(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DatePicker, {
    availableDates: appointmentState.availabilityDates,
    selectedDate: appointmentState.selectedDate,
    onDateChange: date => updateAppointmentState({
      selectedDate: date
    }),
    onWeekChange: handleOnWeekChange,
    disabled: isReloadingSlots || isFetchingDates
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.textRegion
  }, /*#__PURE__*/React.createElement(Text, {
    tagName: "p",
    className: classes.paragraph
  }, `${t('form.appointment.timezone.label')}: ${timezone}`), /*#__PURE__*/React.createElement(Text, {
    tagName: "p",
    className: classes.paragraph
  }, formatInfo)), /*#__PURE__*/React.createElement(TimeSlots, {
    appointmentState: appointmentState,
    appointmentFieldProps: appointmentFieldProps,
    isReloadingSlots: isReloadingSlots,
    onChange: slot => updateAppointmentState({
      selectedSlot: slot
    })
  }));
};
//# sourceMappingURL=index.js.map